<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="数据分析 > 搜索记录列表" style="height:auto" >
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="关键词">
          <el-input size="small" v-model.trim="searchForm.k" placeholder="关键词"></el-input>
        </el-form-item>
        <el-form-item label="搜索IP">
          <el-input size="small" v-model.trim="searchForm.ip" placeholder="搜索IP"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onQuerySubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
         size="small"
        border>
        <el-table-column
          fixed
          prop="id"
          label="ID编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="k"
          show-overflow-tooltip
          label="关键词">
        </el-table-column>
        <el-table-column
            prop="bdSource"
            show-overflow-tooltip
            label="用户来源">
          </el-table-column>
        <el-table-column
          prop="ip"
          label="用户IP"
          show-overflow-tooltip
          width="160">
        </el-table-column>
        <el-table-column
          prop="ipCountry"
          show-overflow-tooltip
          label="国家"
          width="120">
        </el-table-column>
        <el-table-column
          prop="ipProvince"
          width="120"
          label="省份">
        </el-table-column>
        <el-table-column
          prop="ipCity"
          width="120"
          label="城市">
        </el-table-column>
        <el-table-column
          prop="ipArea"
          width="120"
          label="地区">
        </el-table-column>
        <el-table-column
          prop="ipDetail"
          label="服务">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="搜索时间">
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      searchForm: {
        ip: '',
        k: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
    };
  },
  components: {
    pagination
  },
  methods: {
    getSearchData: function() {
      this.optionItem = this.common.extend(this.searchForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/search/record/list', 
        this.optionItem, res => 
        {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onQuerySubmit() {
      this.getSearchData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getSearchData()
    },
  },
  mounted: function() {
      this.getSearchData();
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-input--suffix .el-input__inner {
  padding-right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/rsdata/searchRecordList.vue